import React, { useState, useEffect } from 'react';
import './SelectBox.css';


const SearchSelectTimezone = ({ 
  allTimezones = [], 
  defaultSelectedOptions = [],
  onChange,
  error = ''
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isListVisible, setIsListVisible] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(defaultSelectedOptions);

  // Debug logs
  useEffect(() => {
    console.log('SearchSelectTimezone - allTimezones:', allTimezones);
    console.log('SearchSelectTimezone - defaultSelectedOptions:', defaultSelectedOptions);
  }, [allTimezones, defaultSelectedOptions]);

  useEffect(() => {
    if (defaultSelectedOptions && defaultSelectedOptions.length > 0) {
      setSelectedOptions(defaultSelectedOptions);
    }
  }, [defaultSelectedOptions]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    console.log('SearchSelectTimezone - Search term:', e.target.value);
  };

  const handleSelect = (option) => {
    console.log('SearchSelectTimezone - Selected option:', option);
    if (!selectedOptions.some(selected => 
        selected.value === option.value || selected.id === option.value)) {
      const updatedOptions = [...selectedOptions, option];
      setSelectedOptions(updatedOptions);
      console.log('SearchSelectTimezone - Updated options:', updatedOptions);
      onChange?.(updatedOptions);
    }
    setSearchTerm('');
    setIsListVisible(false);
  };

  const handleRemove = (optionToRemove, index) => {
    console.log('SearchSelectTimezone - Removing option:', optionToRemove, 'at index:', index);
    const updatedOptions = [...selectedOptions];
    updatedOptions.splice(index, 1);
    setSelectedOptions(updatedOptions);
    onChange?.(updatedOptions);
  };

  const filteredOptions = allTimezones.filter(option =>
    option.label && option.label.toLowerCase().includes(searchTerm.toLowerCase()) &&
    !selectedOptions.some(selected => 
      selected.value === option.value || selected.id === option.value)
  );

  // Debug filtered options
  console.log('SearchSelectTimezone - Filtered options:', filteredOptions);
  console.log('SearchSelectTimezone - Search term:', searchTerm);
  console.log('SearchSelectTimezone - Selected options:', selectedOptions);

  // const displayErrors = error;
  const displayErrors = error || '';

  return (
    <div className='search-select-box-container'>
      <span className='choose-active-plan heading-main fts-14 ftw-4'>
        Choose Timezones
      </span>
      <div className='box-whole'>
        <div className='top-section'>
          <div className='select-container left_container'>
            <span className='normal-text fts-15 black'>Select Timezone</span>
          </div>
          <div className='custom-select-box'>
            <input
              type='text'
              placeholder='Search timezones...'
              value={searchTerm}
              onClick={() => setIsListVisible(!isListVisible)}
              onChange={handleSearch}
              className='search-input fts-15 common-text ftw-4'
            />
            <div className='search-select-drop'>
              <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.5 10L0.870833 0.250001L12.1292 0.25L6.5 10Z" fill="#424242"/>
              </svg>
            </div>
            {isListVisible && (
              <div className='options-list-container'>
                <ul>
                  {filteredOptions.length > 0 ? (
                    filteredOptions.map((option, index) => (
                      <li
                        key={index}
                        onClick={() => handleSelect(option)}
                        className='option-item fts-15 common-text ftw-4'
                      >
                        {option.label}
                      </li>
                    ))
                  ) : (
                    <li className='fts-15'>No timezones found</li>
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>
        <div className='selected-plans'>
          <ul>
            {selectedOptions.map((option, index) => (
              <li className='list-selected normal-text fts-15 ftw-2 black' key={index}>
                {option.label}
                <div onClick={() => handleRemove(option, index)} className='remove-icon-container'>
                  <svg className='remove-icon' width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="17" height="17" rx="2" fill="#BD3D44"/>
                    <path d="M4 4L13 13" stroke="white" strokeWidth="2"/>
                    <path d="M13 4L4 13" stroke="white" strokeWidth="2"/>
                  </svg>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {displayErrors.length > 0 && (
        <div className="input-error-message fts-12 ">
          {displayErrors}
        </div>
      )}

      
    </div>
  );
};

export default SearchSelectTimezone;